import { SalesPromoForm } from "./SalesPromoForm/SalesPromoForm.page";


function SalesPromoEditPage() {

  return (
    <SalesPromoForm title="Edit" />
  );
}

export default SalesPromoEditPage;
